import { render, staticRenderFns } from "./bulananPenengah.vue?vue&type=template&id=4945afa4&scoped=true"
import script from "./bulananPenengah.vue?vue&type=script&lang=js"
export * from "./bulananPenengah.vue?vue&type=script&lang=js"
import style0 from "./bulananPenengah.vue?vue&type=style&index=0&id=4945afa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4945afa4",
  null
  
)

export default component.exports